/**
 * The props that make a file input pick a whole folder, subfolders included,
 * each file carrying its `webkitRelativePath`. `webkitdirectory` is not in
 * React's input props; spread in, it reaches the DOM as the attribute every
 * current browser reads (`directory` for the few that read that instead).
 */
export const DIRECTORY_INPUT = { webkitdirectory: '', directory: '' } as Record<string, string>;
